import React from 'react'
import './Profile.css';
import profileImg from '../../images/profile_svg.svg';
import Footer from '../DashBoardLayout/Footer';
import verified from '../../images/verified.svg';
import SecureLS from "secure-ls";

const Profile = () => {
    var ls = new SecureLS();

    const email = ls.get("userEmail");
    const fname = ls.get("fname");
    const lname = ls.get("lname");
    const phno = ls.get("phno");
    const userType = ls.get("userType");
    const userName= fname.charAt(0).toUpperCase() + fname.slice(1)+" " + lname.charAt(0).toUpperCase() + lname.slice(1);
    
    console.log("Inside Profile page User---", email, fname, lname, phno);

    return (
        <div className='profile'>
            <p style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.7rem", marginLeft: "1rem" }}>User Information</p>
            <div className="profile-div">
                <div className="profile-img">
                    <img src={profileImg} alt="" />
                </div>

                <div className='profile-info'>
                    <div className="user-init">
                        <p className='user-init-icon'>{fname.charAt(0).toUpperCase()}{lname.charAt(0).toUpperCase()}</p>
                        <div style={{ display: "flex", margin: "2rem 1rem 1rem 0rem", letterSpacing:"0.03rem", alignItems:"center",justifyContent:"center"}}>
                            <p style={{fontSize:"2.0rem"}}>{userName}</p>
                        </div>
                    </div>

                    <div className="user-details">
                        {/* <div style={{ display: "inline-flex" }}>
                            <p>UserName:- <span>{fname.charAt(0).toUpperCase() + fname.slice(1)} {lname.charAt(0).toUpperCase() + lname.slice(1)}</span>
                            </p>
                            <img src={verified} alt="" height={15} width={15} style={{ margin: "0.67rem 0 0 0.17rem" }} />
                        </div> */}
                        <div className="user-det">
                        <p>Email:- <span>{email}</span></p>
                        <p>Phone Number:- <span>{phno}</span></p>
                        <p>User Type:- <span>{userType}</span></p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer">
                <Footer />
            </div>
        </div>
    )
}

export default Profile